import { render, staticRenderFns } from "./term_&_condition.vue?vue&type=template&id=71ebdbd2"
import script from "./term_&_condition.vue?vue&type=script&lang=js"
export * from "./term_&_condition.vue?vue&type=script&lang=js"
import style0 from "./term_&_condition.vue?vue&type=style&index=0&id=71ebdbd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports